module.exports = __webpack_public_path__ + "img/altitude-resort-5.68e1321d.jpg";